import React,{Fragment,useEffect} from 'react';
import { RootState} from 'ReduxStore/store'
import { Redirect, Route,useHistory ,withRouter,Link,useParams} from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { GetAllResources, GetResourceById } from 'ReduxStore/resources/Action'
import { useStyles } from 'Components/Reusable/Categories/categories.style';
import category from 'Assets/img/svg/categoriesImage.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';


interface RouteParams {
  id:string
}

const ResourceDetails =() => {
  const classes = useStyles();
    const dispatch = useDispatch()
    const resourceCategories:any[] = useSelector((state:RootState) => state.resources['welcome'])
    //eslint-disable-next-line
    console.log(resourceCategories)
    const resourceItem:any = useSelector((state:RootState) => state.resources['resourceItem'])
    //eslint-disable-next-line
    console.log(resourceItem)
    const params = useParams<RouteParams>();
    //eslint-disable-next-line 
    console.log("Id is",params.id)
    useEffect(() => {

        dispatch(GetResourceById(params.id))
    
	  }, []);
    return(
        <Fragment>
            <div className="">
          <Header />

          {
              resourceItem   ? (
                  <div>
                      <h1>{resourceItem.title}</h1>
                  </div>
              ) : "No categories now"
          }
        </div>
        <ul className={classes.listItems}>
          {categories.map(content => (
            <li key={content.id} className="my-3">
              {
                <MenuCard
                  url={content.url}
                  image={content.backgroundImage}
                  type={content.type}
                  common={{ width: '100%', height: '80.74px' }}
                  description={content.description}
                  icon={content.icon}
                />
              }
            </li>
          ))}
        </ul>
        </Fragment>
    )
}

export default ResourceDetails;

